    import React from 'react';

    function Skills() {
        return (
            <div className="max-w-7xl mx-auto my-48">
                <div className="mt-16">
                    <main className="py-6 px-4 sm:p-6 md:py-10 md:px-8">
                        <div className="max-w-4xl mx-auto grid lg:max-w-5xl lg:gap-x-20">
                            <h1 className="text-4xl font-bold text-white">
                                My <span className="text-red-600">Skills</span>
                            </h1>

                            {/* Skills Section */}
                            <section className="mt-8">
                                <h2 className="text-2xl font-bold text-white">Skills</h2>

                                <div className="mt-6">
                                    <h3 className="text-xl font-semibold text-red-600">Languages & Frameworks</h3>
                                    <ul className="mt-4 text-white space-y-2">
                                        <li>- PHP / Laravel / Livewire / Filament</li>
                                        <li>- JavaScript / React / Next.js / jQuery</li>
                                        <li>- Ruby on Rails</li>
                                        <li>- TailwindCSS / Alpine.js / CSS3 / HTML5</li>
                                    </ul>
                                </div>

                                <div className="mt-6">
                                    <h3 className="text-xl font-semibold text-red-600">CMS & Content</h3>
                                    <ul className="mt-4 text-white space-y-2">
                                        <li>- Sanity / Contentful (Headless CMS)</li>
                                        <li>- WordPress / Bitrix24</li>
                                    </ul>
                                </div>

                                <div className="mt-6">
                                    <h3 className="text-xl font-semibold text-red-600">Database</h3>
                                    <ul className="mt-4 text-white space-y-2">
                                        <li>- MySQL</li>
                                    </ul>
                                </div>

                                <div className="mt-6">
                                    <h3 className="text-xl font-semibold text-red-600">DevOps & Deployment</h3>
                                    <ul className="mt-4 text-white space-y-2">
                                        <li>- Docker / DDEV</li>
                                        <li>- Git / GitHub / GitLab / CI-CD</li>
                                        <li>- Vercel</li>
                                    </ul>
                                </div>

                                <div className="mt-6">
                                    <h3 className="text-xl font-semibold text-red-600">UI Development & Tooling</h3>
                                    <ul className="mt-4 text-white space-y-2">
                                        <li>- Storybook</li>
                                        <li>- RESTful APIs</li>
                                        <li>- JetBrains / VSCode / Sublime Text / Terminal Workflow</li>
                                        <li>- Linux / Windows / Mac</li>
                                    </ul>
                                </div>

                                <div className="mt-6">
                                    <h3 className="text-xl font-semibold text-red-600">Ways of Working</h3>
                                    <ul className="mt-4 text-white space-y-2">
                                        <li>- Agile / Scrum</li>
                                    </ul>
                                </div>
                            </section>

                            {/* Download Resume Button */}
                            {/*<section className="mt-8">*/}
                            {/*    <button className="bg-red-600 text-white px-6 py-2 rounded hover:bg-red-700">*/}
                            {/*        Download Resume*/}
                            {/*    </button>*/}
                            {/*</section>*/}
                        </div>
                    </main>
                </div>
            </div>
        );
    }

    export default Skills;